module.exports = __webpack_public_path__ + "img/1024485944.28d1b929.png";